module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QAGwB6ANLfyEOSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QccDxk25sUtDAAAASdJREFUOMtj/P///38GBgaGii1PGWafeMtADEi1EGbo8JFmYGBgYGCCCRKrGV0tC7KEFB8rw+UyTbyadTqvMTz//AfOZ0KWZGdhxKnxw3eIJh1JThRxJmKdrdx6jeHC028MK+IUGfy0+Uk3gIGBgcF5+h2GDZc/MMyPlMceBjCw4NRbhuJNT7EakrzyEcPVFz8YqlzEGRgZGbG74Pe//3hd0nfwFUPE4gcMf/7+J80L2ABWL7AyMeLVVGQvBvcCVgMSzIQZEsyEUcSEay4xMDAwMEwLlmUINxQkLxb2ZqowhBsKMiQuf4jfC9jA3WotBgFOFobIxfcZdt38jN2An3//M7z/9oeBEUcQvP36h+Hi0++4A/HZx98MKm3XSIoFJuQsSixAVgsAofxX2U4adHUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/logout.png
// module id = 245
// module chunks = 0